import type { Character } from '../core/character';
import { DISCOVERY_HUD_TITLE } from '../ui/hud/DiscoveryHud';

/**
 * Roster row sub-element: a discoveries readout that matches the in-game HUD
 * (HEX-38). Lives in its own module so DOM tests can exercise it without
 * importing `App.ts` (which pulls in the Pixi renderer at module-load time).
 */
export function renderRosterDiscoveries(character: Character): HTMLSpanElement {
  const span = document.createElement('span');
  span.className = 'hex6-roster-discoveries';
  span.dataset.discoveries = String(character.discoveries);
  span.textContent = `${character.discoveries} discovered`;
  span.title = DISCOVERY_HUD_TITLE;
  span.style.cssText = 'font-size:11px;opacity:0.75;letter-spacing:0.05em;color:#f0d264;';
  return span;
}
